import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, PHONE_TEL, PHONE_DISPLAY, EMAIL, ADDRESS, PIVA, WHATSAPP_URL } from "@/data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-carbone text-ivory/80">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="mb-8">
          <img
            src="/assets/logo-sopaj.png"
            alt="SOPAJ — Impresa Edile"
            className="h-12 w-auto"
            width="200"
            height="67"
            loading="lazy"
          />
        </div>
        <p className="font-serif italic text-xl text-ivory/90 max-w-sm">
          Ristrutturare casa, senza pensieri.
        </p>
        <p className="mt-4 text-sm text-ivory/50 leading-relaxed max-w-sm">
          Impresa edile con sede a Nibionno, specializzata in ristrutturazioni
          complete e lavori chiavi in mano. Disponibilità anche al di fuori della zona di sede.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="font-display text-xs tracking-[0.3em] uppercase text-ivory/40 mb-6">Contatti</p>
        <ul className="space-y-4 text-sm">
          <li>
            <a href={PHONE_TEL} data-testid="footer-phone" className="flex items-start gap-3 hover:text-terracotta transition-colors duration-300">
              <Phone size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" /> {PHONE_DISPLAY}
            </a>
          </li>
          <li>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-start gap-3 hover:text-terracotta transition-colors duration-300">
              <Phone size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" /> WhatsApp
            </a>
          </li>
          <li>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-start gap-3 hover:text-terracotta transition-colors duration-300">
              <Mail size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" /> {EMAIL}
            </a>
          </li>
          <li className="flex items-start gap-3 text-ivory/50">
            <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" /> {ADDRESS}
          </li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <p className="font-display text-xs tracking-[0.3em] uppercase text-ivory/40 mb-6">Il sito</p>
        <ul className="space-y-3 text-sm">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="hover:text-terracotta transition-colors duration-300">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <p className="font-display text-xs tracking-[0.3em] uppercase text-ivory/40 mb-6">Note legali</p>
        <ul className="space-y-3 text-sm">
          <li>
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-terracotta transition-colors duration-300">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-terracotta transition-colors duration-300">
              Cookie Policy
            </Link>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-ivory/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-ivory/40">
        <p data-testid="footer-legal-line">
          Sopaj Demir — Impresa Edile · P. IVA {PIVA} · www.sopaj.it
        </p>
        <p>Sede: Nibionno (LC) — Operatività senza confini rigidi</p>
      </div>
    </div>
  </footer>
);

export default Footer;
